import React from 'react';
import { prizeAboutModalContent, prizeMonthAboutModalContent } from '../../../constants/copyright';
import { useModal } from '../../../hooks/useModal';
import { useLocalStorageModals } from '../../../hooks/useLocalStorageModals';
import { getMonthName } from '../../../utils/helpers';
import PrizesBody from './PrizesBody';
import { useTranslation } from '../../../translations';

const PrizesCommon = React.forwardRef(function PrizesCommon({ isMonth, isGamesRatingPrizes }, ref) {
  const prizeContent = isMonth ? prizeMonthAboutModalContent : prizeAboutModalContent;

  const {
    className,
    buttons: { enterModal, prizeModal },
  } = prizeContent;
  const { addModal } = useModal();
  const { t } = useTranslation();

  // const currentPrizes = isMonth ? ratingPrizes?.ratingPrizes : ratingPrizes?.weekRatingPrizes;
  const currentPrizes = prizeContent.prizes;

  const modifiedDescription = isMonth
    ? t(prizeContent.description).replace('{monthId}', getMonthName(Date.now() / 1000, 'ru-RU', true, t))
    : prizeContent.description;

  const aboutModalProps = {
    ...prizeContent,
    buttons: enterModal,
    description: modifiedDescription,
  };

  const showAboutModal = () => {
    addModal({
      type: 'aboutModal',
      props: aboutModalProps,
    });
  };

  const showPrizeInfo = ({ image: img, title, description }) =>
    addModal({
      type: 'aboutModal',
      props: { className, img, title, description, buttons: prizeModal },
    });

  useLocalStorageModals([
    {
      id: `aboutPrizesModal${isMonth ? 'Month' : 'Week'}`,
      type: 'aboutModal',
      props: aboutModalProps,
    },
  ]);

  return (
    <PrizesBody
      isGamesRatingPrizes={isGamesRatingPrizes}
      currentPrizes={currentPrizes}
      showPrizeInfo={showPrizeInfo}
      showAboutModal={showAboutModal}
    />
  );
});
export default PrizesCommon;
PrizesCommon.propTypes = {};
